import type { TeamMemberRole } from '@/api/beatlyApi';

export interface TeamRoleOption {
  value: TeamMemberRole;
  label: string;
  description?: string;
}

/**
 * True when the team role may set curation/draft reviewer defaults and campaign overrides.
 * EXTERNAL_PARTNER is read-only for reviewer assignment UX.
 */
export function canManageReviewerAssignments(role: string): boolean {
  return role === 'ADMIN' || role === 'MARKETING_MANAGER';
}

/** Builds Admin / Manager / Member options from i18n; descriptions optional for invite picker. */
export function buildTeamRoleOptions(
  t: (key: string) => string,
  withDescriptions: boolean,
): TeamRoleOption[] {
  return [
    {
      value: 'ADMIN',
      label: t('teamPage.invite.roles.admin.label'),
      description: withDescriptions ? t('teamPage.invite.roles.admin.description') : undefined,
    },
    {
      value: 'MARKETING_MANAGER',
      label: t('teamPage.invite.roles.manager.label'),
      description: withDescriptions ? t('teamPage.invite.roles.manager.description') : undefined,
    },
    {
      value: 'EXTERNAL_PARTNER',
      label: t('teamPage.invite.roles.member.label'),
      description: withDescriptions ? t('teamPage.invite.roles.member.description') : undefined,
    },
  ];
}
